// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IVp9R_8GAD4Dz0tf6WY8>div>*{overflow:visible}.ZIHyhMcPlgMRBTOmSRMB{margin:0 8px}.MXysATG6VO0eCAmWjDzq{margin:0 8px 8px}.v74tCs_XfRAIJuPrGgpG{color:var(--content-primary-tertiary);justify-content:center;align-items:center;padding:12px;display:flex}.YvXf5vT7ko9Kqf7QjqM9{color:var(--content-brand-primary);cursor:pointer;font-size:14px;font-weight:500}.Vke2oM66jknSpYwBb5rq{flex-direction:column;margin:0 16px;display:flex}.CCQ_4svBjuc2bsxnfiSq{flex-wrap:wrap;gap:4px;padding-bottom:16px;display:flex}.AnN7xEnm0pIJOdiM5wIL{min-height:72px}.eIngjhLTmgmAqEAg0WVx{margin:0 16px 4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tagModal": `IVp9R_8GAD4Dz0tf6WY8`,
	"list": `ZIHyhMcPlgMRBTOmSRMB`,
	"fieldList": `MXysATG6VO0eCAmWjDzq`,
	"noResults": `v74tCs_XfRAIJuPrGgpG`,
	"reconnectBtn": `YvXf5vT7ko9Kqf7QjqM9`,
	"descriptionStep": `Vke2oM66jknSpYwBb5rq`,
	"fieldChips": `CCQ_4svBjuc2bsxnfiSq`,
	"textarea": `AnN7xEnm0pIJOdiM5wIL`,
	"actionStep": `eIngjhLTmgmAqEAg0WVx`
};
export default ___CSS_LOADER_EXPORT___;
